var transformAncestor,
    transformBookmark,
    transformBookmarkMediaItem,
    transformMediaLinks = require("app/Domain/Ott/Api/V2/DataTransformers/transformMediaLinks");

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language   The current application language
 * @param    {Object}  bookmarks  The bookmarks data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformBookmarks = function(language, bookmarks) {
    bookmarks = bookmarks || [];
    bookmarks
        .filter(function(bookmark) {
            // Reject bookmarks without media item. This can happen if the media
            // item isn't published anymore.
            return Boolean(bookmark.media_item);
        })
        .map(function(bookmark) {
            return transformBookmark(language, bookmark);
        });

    return bookmarks;
};

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  bookmark  The bookmark data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformBookmark = transformBookmark = function(language, bookmark) {
    switch (bookmark.media_item.type) {
        case "album_track":
        case "artist_page":
        case "audio":
        case "book":
        case "brand":
        case "category":
        case "episode":
        case "external":
        case "issue":
        case "magazine":
        case "music_album":
        case "page":
        case "photo":
        case "playlist_page":
        case "podcast":
        case "podcast_episode":
        case "product":
        case "product_category":
        case "series":
        case "video":
            bookmark.media_item = transformBookmarkMediaItem(language, bookmark.media_item);

            return bookmark;
        default:
            return bookmark;
    }
};

/**
 * Adds links to bookmark mediaItem item.
 *
 * @param    {string}  language   The current application language
 * @param    {Object}  media      The mediaItem data
 * @returns  {Object}  The transformed data
 * @private
 */
transformBookmarkMediaItem = function(language, media) {
    // Add links
    media = transformMediaLinks(language, media);

    if (media.parent && typeof media.parent === "object") {
        media.parent = transformAncestor(language, media.parent);
    }

    return media;
};

/**
 * Adds links to ancestor.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  media     The media data
 * @returns  {Object}  The transformed data
 * @public
 */
transformAncestor = function(language, media) {
    media = transformMediaLinks(language, media);

    if (media.parent && typeof media.parent === "object") {
        media.parent = transformAncestor(language, media.parent);
    }

    return media;
};
